<template>
  <div class="flex flex-col home vld-parent">
    <loading :active.sync="$apollo.loading" :is-full-page="true" />
    <div class="flex flex-col items-center flex-grow mt-4">
      <div class="w-4/5 px-4 py-2 mb-4 bg-gray-200 border-gray-200 rounded-lg shadow-md">
        <p class="mb-2 ml-1">Search</p>
        <t-input class="w-full mb-2" v-model="debouncedSearch" />
        <p class="mb-2 ml-1">Filters</p>
        <t-select placeholder="Store type" :options="storeOptions" v-model="storeType"></t-select>
      </div>
      <div
        v-for="(product, index) in filtered"
        :key="index"
        class="flex items-center justify-between w-4/5 px-4 py-4 mb-4 border border-gray-200 shadow-lg rounded-md"
        @click="handleProductClicked(index)"
      >
        <div class="flex items-center lg:space-x-4 space-x-2">
          <img
            v-if="product.imageURL"
            :src="product.imageURL"
            alt="Product Image"
            class="object-contain h-16"
          />
          <div class="flex flex-col pr-8">
            <span class="font-light tracking-wide uppercase">
              {{ product.name }}
            </span>
            <span
              class="text-sm tracking-wider text-gray-500"
              :class="{
                'text-blue-600': product.type === 'walmart',
                'text-red-600': product.type === 'target',
              }"
            >
              {{ product.upc }}
            </span>
          </div>
        </div>
        <div>
          <span class="text-xl text-bold"> ${{ product.price }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GET_PRODUCTS from '@/graphql/GetProducts';

export default {
  name: 'Products',
  data() {
    return {
      storeType: '',
      search: '',
      storeOptions: [
        { value: '', text: 'All' },
        { value: 'walmart', text: 'Walmart' },
        { value: 'lowes', text: "Lowe's" },
        { value: 'target', text: 'Target' },
      ],
    };
  },
  beforeDestroy() {
    if (this.search) sessionStorage.setItem('search', this.search);
    else sessionStorage.removeItem('search');
    if (this.storeType) sessionStorage.setItem('storeType', this.storeType);
    else sessionStorage.removeItem('storeType');
  },
  created() {
    if (sessionStorage.getItem('storeType')) {
      this.storeType = sessionStorage.getItem('storeType');
    }
    if (sessionStorage.getItem('search')) {
      this.search = sessionStorage.getItem('search');
    }
  },
  apollo: {
    products: { query: GET_PRODUCTS, update: (data) => data.ProductMany },
  },
  computed: {
    debouncedSearch: {
      get() {
        return this.search;
      },
      set(val) {
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.search = val;
        }, 200);
      },
    },
    filtered() {
      let filteredProducts = this.products;
      if (this.storeType !== 'all' && this.storeType) {
        filteredProducts = this.products.filter((e) => e.type === this.storeType);
      }
      if (this.search !== '') {
        const search = this.search.toLowerCase();
        filteredProducts = filteredProducts.filter(
          (elem) =>
            elem.name.toLowerCase().includes(search) || elem.upc.toLowerCase().includes(search),
        );
      }
      return filteredProducts;
    },
  },
  methods: {
    handleProductClicked(index) {
      const { _id, ...rest } = this.filtered[index];
      this.$store.commit('setActiveProduct', { _id, ...rest });
      this.$router.push(`products/${_id}`);
    },
  },
};
</script>
